/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskSuggestionResponseDto } from '../../models/core-project-subtask-suggestion-response-dto';

export interface ProjectSubtasksControllerGetSuggestion$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The task ID to get suggestions for.
 */
  taskId: string;
}

export function projectSubtasksControllerGetSuggestion(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerGetSuggestion$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskSuggestionResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerGetSuggestion.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('taskId', params.taskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskSuggestionResponseDto>;
    })
  );
}

projectSubtasksControllerGetSuggestion.PATH = '/o2-core/project-subtasks/{tenant}/suggestion';
